module.exports = __webpack_public_path__ + "img/gold-onboard-image.47562fac.svg";